module.exports = __webpack_public_path__ + "static/media/WG300.a19a9cc2.png";